import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Testimonials.css";
import testimonial2 from "../assets/testimonials/Bar_mantra.jpg";
import testimonial1 from "../assets/testimonials/udit_maheswari.jpeg";
import testimonial3 from "../assets/testimonials/Disha_singh.jpeg";

const testimonials = [
  {
    name: "Ram Ratan Gurjar",
    company: "M/S Shyam Udhyog", 
    image: testimonial1,
    feedback: "Exceptional product quality and outstanding service. Highly satisfied!",
  },
  {
    name: "Mohit khanna",
    company: "Bar Mantra",
    image: testimonial2,
    feedback: "Fantastic service and high-quality water! Highly recommended.",
  },
  {
    name: "Disha Singh",
    company: "Singh Beverages",
    image: testimonial3,
    feedback: "Great packaging, timely delivery, and superb taste.",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials-wrapper">
      <h2 className="testimonials-title">What Our Customers Say</h2>
      <Swiper
        modules={[Pagination, Autoplay]}
        slidesPerView={1} // Mobile: 1 slide at a time
        spaceBetween={20}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          768: { slidesPerView: 1 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
        style={{ width: "100%", overflow: "hidden" }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index} className="testimonial-card">
            <img src={testimonial.image} alt={testimonial.name} className="testimonial-img" />
            <h3 className="testimonial-name">{testimonial.name}</h3>
            <p className="testimonial-company">{testimonial.company}</p> {/* Company Name */}
            <p className="testimonial-feedback">"{testimonial.feedback}"</p>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
